export const showMaropostForNonSuperUser = false;
export const showRecipientEmailForNonSuperUser = false;



// WEBPACK FOOTER //
// ./src/configuration.js